export default {
  en: [
    {
      label: "Select",
      value: ""
    },
    {
      label: "Ontario",
      value: "on"
    },
    {
      label: "Alberta",
      value: "ab"
    },
    {
      label: "British Columbia",
      value: "bc"
    }
  ],
  fr: [
    {
      label: "Sélectioner",
      value: ""
    },
    {
      label: "Ontario",
      value: "on"
    },
    {
      label: "Alberta",
      value: "ab"
    },
    {
      label: "Colombie-Britannique",
      value: "bc"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/provinces.data.js